import React from 'react';

import LogoNavSVG from '../../svgs/LogoNav';
import InfinitySVG from '../../svgs/Infinity';
import DistributionSVG from '../../svgs/Distribution';
import VideoSVG from '../../svgs/Video';
import GraphSVG from '../../svgs/Graph';
import GlobeSVG from '../../svgs/Globe';
import EditingScissors from '../../svgs/EditingScissors';
import EpisodeBuilderSVG from '../../svgs/EpisodeBuilder';
import AnchorPayLogoSVG from '../../svgs/AnchorPayLogo';
import MicrophoneSVG from '../../svgs/Microphone';
import TwoPeopleSVG from '../../svgs/TwoPeople';
import SwitchArrowsSVG from '../../svgs/SwitchArrows';

const SIGNED_OUT_LINKS = [
  {
    label: 'FEATURES',
    key: 'features',
    to: '/features',
    subLinks: [
      {
        to: '/features',
        svg: <LogoNavSVG color="#292f36" width={18} height={22} />,
        label: 'Overview',
        key: 'overview',
      },
      {
        to: '/features#unlimitedHosting',
        anchorId: 'unlimitedHosting',
        svg: <InfinitySVG color="#292f36" width={18} height={20} />,
        label: 'Unlimited Free Hosting',
      },
      {
        to: '/features#distribution',
        anchorId: 'distribution',
        svg: <DistributionSVG color="#292f36" width={18} height={19} />,
        label: 'One-Click Distribution',
      },
      {
        to: '/features#monetize',
        anchorId: 'monetize',
        svg: <AnchorPayLogoSVG color="#292f36" width={18} height={15} />,
        label: 'Monetize Your Podcast',
      },
      {
        to: '/features#podcastWithFriends',
        anchorId: 'podcastWithFriends',
        svg: <TwoPeopleSVG color="#292f36" width={18} height={18} />,
        label: 'Podcast With Friends',
      },
      {
        to: '/features#analytics',
        anchorId: 'analytics',
        svg: <GraphSVG color="#292f36" size={18} />,
        label: 'Straightforward Analytics',
      },
      {
        to: '/features#recordAnywhere',
        anchorId: 'recordAnywhere',
        svg: <GlobeSVG color="#292f36" width={18} height={19} />,
        label: 'Record From Anywhere',
      },
      {
        to: '/features#episodeBuilder',
        anchorId: 'episodeBuilder',
        svg: <EpisodeBuilderSVG color="#292f36" width={18} height={18} />,
        label: 'Episode Builder',
      },
      {
        to: '/features#editingTools',
        anchorId: 'editingTools',
        svg: <EditingScissors color="#292f36" width={18} height={20} />,
        label: 'Editing Tools',
      },
      {
        to: '/features#creationTools',
        anchorId: 'creationTools',
        svg: <MicrophoneSVG color="#292f36" width={18} height={18} />,
        label: 'Creation Tools',
      },
      {
        to: '/features#transcribedVideos',
        anchorId: 'transcribedVideos',
        svg: <VideoSVG color="#292f36" size={18} />,
        label: 'Transcribed Videos',
      },
      {
        to: '/features#switch',
        anchorId: 'switch',
        svg: <SwitchArrowsSVG color="#292f36" width={18} height={18} />,
        label: 'Switch to Anchor',
      },
    ],
  },
  {
    label: 'SWITCH TO ANCHOR',
    key: 'switch',
    to: '/switch',
  },
  {
    label: 'PODCASTING TIPS',
    key: 'podcastingTips',
    href: 'https://medium.com/anchor',
    openInNewTab: true,
  },
];

// TODO: add back episodes link when the episodes page is ready
const SIGNED_IN_LINKS = [
  {
    label: 'DASHBOARD',
    key: 'dashboard',
    to: '/dashboard',
  },
  {
    label: 'EPISODES',
    key: 'episodes',
    to: '/dashboard/episodes',
  },
  {
    label: 'MONEY',
    key: 'money',
    to: '/dashboard/money',
    notificationBadge: 'DollarSignIcon',
  },
];

const ACCOUNT_MENU_ITEMS = [
  {
    label: 'Update settings',
    icon: {
      type: 'GearIcon',
      iconColor: '#c9cbcd',
      backgroundColor: 'transparent',
      width: 18,
      padding: 0,
    },
    to: '/dashboard/podcast/edit',
  },
  {
    label: 'Help',
    icon: {
      type: 'QuestionMarkIcon',
      iconColor: '#ffffff',
      backgroundColor: 'gray',
      width: 18,
      padding: 3,
    },
    target: '_blank',
    href: 'https://help.anchor.fm/',
  },
];

export { SIGNED_OUT_LINKS, SIGNED_IN_LINKS, ACCOUNT_MENU_ITEMS };
